module.exports = __webpack_public_path__ + "media/images/sales/early/heading-recommend-c57c1bc2acdc206ce5ceb83fca096a71.svg";